export const LOCALISATION_WHITELIST_DOMAIN = [
  process.env.NEXT_PUBLIC_BASE_SERVICES_URL,
  process.env.NEXT_PUBLIC_AUTH_DOMAIN,
  process.env.NEXT_PUBLIC_BFF_DOMAIN,
  process.env.NEXT_PUBLIC_ADDRESS_SERVICE,
  process.env.NEXT_PUBLIC_CART_SERVICES,
  process.env.NEXT_PUBLIC_QUINCE_STORE_FRONT_BUILD_API,
  process.env.NEXT_PUBLIC_QUINCE_STORE_FRONT_RUNTIME_API,
  process.env.NEXT_PUBLIC_REPORTING_SERVICES,
  process.env.NEXT_PUBLIC_PRESENTATION_LAYER_SERVICE,
] as const
